<template>
  <InternalLink
    v-if="link && link[0]?._type == 'internalLink'"
    v-bind="link[0]"
    :class="computedClass"
  >
    {{ text }}
  </InternalLink>
  <ExternalLink
    v-else-if="link && link[0]?._type == 'externalLink'"
    v-bind="link[0]"
    :class="computedClass"
  >
    {{ text }}
  </ExternalLink>
</template>

<script lang="ts" setup>
import InternalLink from '~/components/Atoms/InternalLink/InternalLink.vue';
import ExternalLink from '~/components/Atoms/ExternalLink/ExternalLink.vue';
import { computed } from 'vue';
import type { MicroSiteNavButton } from '~/sanity/types';
import { backgroundColorClasses } from '~/components/Atoms/Background/BgColorMap';
interface Props extends MicroSiteNavButton {
  buttonStyle?: string;
}
const props = defineProps<Props>();
const { buttonStyle } = toRefs(props);
const buttonClass = computed(() => {
  return buttonClasses[buttonStyle.value ?? 'transparent'] ?? buttonClasses['transparent'];
});
const computedClass = computed(() => [
  'inline-block w-full cursor-pointer px-5 py-2 font-ptc-Rajdhani text-lg font-bold uppercase leading-18px border-b-2',
  'hover:border-b-www-color-primary-lighter hover:bg-www-color-transparent transition-all duration-300',
  !props.activeState ? 'border-www-color-transparent' : '',
  props.activeState ? 'border-2 border-www-color-primary-lighter rounded' : '',
  buttonClass.value,
]);

const buttonClasses: Record<string, string> = {
  ...backgroundColorClasses,
  transparent:
    'border-www-color-primary-lighter bg-www-color-transparent text-www-color-white hover:border-www-color-primary-light focus:border-2 active:border-www-color-primary-light active:text-www-color-primary-lighter',
  'secondary-alt':
    'border-www-color-neutral-medium bg-www-color-white text-www-color-neutral-medium hover:text-www-color-neutral-medium focus:border-2 active:text-www-color-neutral-medium-dark',
};
</script>

<style></style>
